import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

function Landing() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--body-bg)' }}>
      {/* Navigation */}
      <nav style={{
        background: 'white',
        borderBottom: '1px solid var(--border-color)',
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: 'var(--shadow-sm)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <img src={logo} alt="Spark QR" style={{ height: '40px' }} />
          <div>
            <h3 style={{ margin: 0, fontSize: '1.5rem', color: 'var(--primary)' }}>Spark QR</h3>
            <p style={{ margin: 0, fontSize: '0.75rem', color: 'var(--gray-600)' }}>
              by BizHub
            </p>
          </div>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/login')}>
          Sign In
        </button>
      </nav>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #626ed4 0%, #7c88e8 50%, #02a499 100%)',
        color: 'white',
        padding: '6rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: 700,
            marginBottom: '1.5rem',
            color: 'white',
            lineHeight: 1.2
          }}>
            Professional QR Code Management for Modern Businesses
          </h1>
          <p style={{
            fontSize: '1.25rem',
            marginBottom: '2rem',
            opacity: 0.95,
            lineHeight: 1.6
          }}>
            Create stunning branded QR codes with advanced analytics, dynamic URL editing, and enterprise-grade tracking. Manage campaigns effortlessly.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              className="btn btn-success"
              onClick={() => navigate('/login')}
              style={{ fontSize: '1.125rem', padding: '0.75rem 2rem' }}
            >
              Get Started Free
            </button>
            <button
              className="btn btn-light"
              onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}
              style={{ fontSize: '1.125rem', padding: '0.75rem 2rem', color: 'var(--primary)' }}
            >
              Learn More
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" style={{ padding: '5rem 2rem', background: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
              Everything You Need to Manage QR Campaigns
            </h2>
            <p style={{ fontSize: '1.125rem', color: 'var(--gray-600)' }}>
              Enterprise-grade features for businesses of all sizes
            </p>
          </div>

          <div className="grid grid-cols-3" style={{ gap: '2rem' }}>
            {/* Feature 1 */}
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, var(--primary), var(--purple))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2.5rem',
                margin: '0 auto 1.5rem'
              }}>
                🎨
              </div>
              <h4 style={{ marginBottom: '1rem' }}>Artistic QR Codes</h4>
              <p className="text-muted">
                12+ professional presets with custom frames, patterns, and colors. Stand out with branded QR codes.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, var(--success), var(--cyan))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2.5rem',
                margin: '0 auto 1.5rem'
              }}>
                🔄
              </div>
              <h4 style={{ marginBottom: '1rem' }}>Dynamic URL Editing</h4>
              <p className="text-muted">
                Change where your QR code redirects anytime - no need to reprint. Update campaigns on the fly.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, var(--info), var(--primary))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2.5rem',
                margin: '0 auto 1.5rem'
              }}>
                📊
              </div>
              <h4 style={{ marginBottom: '1rem' }}>Advanced Analytics</h4>
              <p className="text-muted">
                Track scans with geolocation, device types, referrers, and time-of-day insights. Export to CSV.
              </p>
            </div>

            {/* Feature 4 */}
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, var(--warning), var(--orange))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2.5rem',
                margin: '0 auto 1.5rem'
              }}>
                📱
              </div>
              <h4 style={{ marginBottom: '1rem' }}>Campaign Management</h4>
              <p className="text-muted">
                Organize QR codes by campaigns. Search, filter, and track performance across all your marketing efforts.
              </p>
            </div>

            {/* Feature 5 */}
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, var(--danger), var(--pink))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2.5rem',
                margin: '0 auto 1.5rem'
              }}>
                ⏰
              </div>
              <h4 style={{ marginBottom: '1rem' }}>Expiration Control</h4>
              <p className="text-muted">
                Set expiration dates for time-sensitive campaigns. Perfect for limited offers and events.
              </p>
            </div>

            {/* Feature 6 */}
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, var(--purple), var(--primary))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2.5rem',
                margin: '0 auto 1.5rem'
              }}>
                ⚡
              </div>
              <h4 style={{ marginBottom: '1rem' }}>Lightning Fast</h4>
              <p className="text-muted">
                Instant redirects with &lt; 100ms response time. Your customers reach their destination immediately.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section style={{ padding: '5rem 2rem', background: 'var(--gray-100)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div className="row" style={{ alignItems: 'center' }}>
            <div className="col-md-6">
              <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>
                Why Choose Spark QR?
              </h2>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                <div style={{ display: 'flex', gap: '1rem' }}>
                  <span style={{ fontSize: '2rem' }}>✅</span>
                  <div>
                    <h5>Enterprise-Grade Security</h5>
                    <p className="text-muted">
                      Invite-only registration, admin controls, and secure authentication with JWT tokens.
                    </p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '1rem' }}>
                  <span style={{ fontSize: '2rem' }}>🌍</span>
                  <div>
                    <h5>Global Geolocation Tracking</h5>
                    <p className="text-muted">
                      See where your scans come from with city-level accuracy using IPStack API.
                    </p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '1rem' }}>
                  <span style={{ fontSize: '2rem' }}>🎨</span>
                  <div>
                    <h5>Beautiful Brand Consistency</h5>
                    <p className="text-muted">
                      Match your brand with custom colors, logos, frames, and 12 artistic presets.
                    </p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '1rem' }}>
                  <span style={{ fontSize: '2rem' }}>📈</span>
                  <div>
                    <h5>Actionable Insights</h5>
                    <p className="text-muted">
                      Real-time analytics with device breakdown, time-of-day patterns, and referrer tracking.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card" style={{ padding: '2rem', background: 'white' }}>
                <h4 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
                  What You Get
                </h4>
                <ul style={{ listStyle: 'none', padding: 0, lineHeight: 2 }}>
                  <li>✓ Unlimited projects and campaigns</li>
                  <li>✓ Unlimited QR code creation</li>
                  <li>✓ Advanced analytics and reporting</li>
                  <li>✓ Custom branding and logos</li>
                  <li>✓ CSV data export</li>
                  <li>✓ UTM campaign tracking</li>
                  <li>✓ Expiration date management</li>
                  <li>✓ 3 view modes (Grid/List/Table)</li>
                  <li>✓ Search and filter by campaign</li>
                  <li>✓ Download PNG, SVG formats</li>
                  <li>✓ Clone QR codes instantly</li>
                  <li>✓ Mobile responsive design</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '5rem 2rem',
        background: 'linear-gradient(135deg, var(--primary) 0%, var(--purple) 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem', color: 'white' }}>
            Ready to Elevate Your QR Code Campaigns?
          </h2>
          <p style={{ fontSize: '1.125rem', marginBottom: '2rem', opacity: 0.95 }}>
            Join businesses using Spark QR to create, track, and optimize their QR code marketing.
          </p>
          <button
            className="btn btn-success"
            onClick={() => navigate('/login')}
            style={{ fontSize: '1.25rem', padding: '1rem 2.5rem' }}
          >
            Get Started Now
          </button>
          <p style={{ fontSize: '0.875rem', marginTop: '1rem', opacity: 0.8 }}>
            Invite-only access. Contact admin for invite code.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        background: 'var(--dark)',
        color: 'white',
        padding: '3rem 2rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div className="row mb-4">
            <div className="col-md-4" style={{ textAlign: 'left' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
                <img src={logo} alt="Spark QR" style={{ height: '32px' }} />
                <div>
                  <h5 style={{ margin: 0, color: 'white' }}>Spark QR</h5>
                  <p style={{ margin: 0, fontSize: '0.75rem', opacity: 0.7 }}>by BizHub</p>
                </div>
              </div>
              <p style={{ opacity: 0.8, fontSize: '0.875rem' }}>
                Professional dynamic QR code management platform for enterprises and growing businesses.
              </p>
            </div>
            <div className="col-md-4" style={{ textAlign: 'left' }}>
              <h6 style={{ color: 'white', marginBottom: '1rem' }}>Features</h6>
              <ul style={{ listStyle: 'none', padding: 0, opacity: 0.8, fontSize: '0.875rem', lineHeight: 1.8 }}>
                <li>Artistic QR Codes</li>
                <li>Dynamic URL Editing</li>
                <li>Campaign Management</li>
                <li>Analytics & Tracking</li>
                <li>Custom Branding</li>
              </ul>
            </div>
            <div className="col-md-4" style={{ textAlign: 'left' }}>
              <h6 style={{ color: 'white', marginBottom: '1rem' }}>Platform</h6>
              <ul style={{ listStyle: 'none', padding: 0, opacity: 0.8, fontSize: '0.875rem', lineHeight: 1.8 }}>
                <li>Geolocation Tracking</li>
                <li>UTM Parameters</li>
                <li>Expiration Dates</li>
                <li>Admin Controls</li>
                <li>Invite-Only Access</li>
              </ul>
            </div>
          </div>
          <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '2rem', opacity: 0.8 }}>
            <p style={{ margin: 0, fontSize: '0.875rem' }}>
              © {new Date().getFullYear()} Spark QR. A product of BizHub. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
